export const ItemTypes = {
    LIST_ITEM: 'list_item'
};
